import * as yup from "yup";

export const validationSchema = yup.object().shape({
  anonId: yup.string().required("Private ID is not valid."),
  password: yup.string().required("Password is not valid."),
});
